import React from "react";
import "./CityCard.css";
import { Box, Stack, Typography, IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import arrowImage from "../../assets/arrowImage.svg";
import locationImage from "../../assets/locationImage.svg";
import routingImage from "../../assets/routingImage.svg";
import radarImage from "../../assets/radarImage.svg";
import { useLocation, useNavigate } from "react-router";
import StatusCard from "./StatusCard";
import {
  APPERROR,
  CANCELED,
  CANCELEDGUIDE,
  DARCKCOLOR,
  DARCKOPACITYBACKGROUND6,
  DARCKOPACITYBACKGROUND8,
  languageMap,
  SOMEERROR,
  TYPEIMAGE,
  TYPEVIDEO,
} from "../../helpers/Config";
import EditIcon from "@mui/icons-material/Edit";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import { getBookingsCancel } from "../../services/bookings";
import {
  setBookings,
  setSelectedBookings,
  setShowMessageObj,
} from "../../store/userSlice";
import { trackMixpanel } from "../../services/mixpanel";
import {
  sxColumnStartBetween,
  sxRowCenterBetween,
  sxRowCenterStart,
  sxText1230016,
  sxText1240016,
  sxText1450020,
} from "../../theme/sxStyle";
import { handleCloseBookingIdAlert } from "../../helpers/Utils";

const sxImage = {
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  borderRadius: "24px",
  objectFit: "cover",
  background: `linear-gradient(to bottom, rgba(33, 37, 41, 0), ${DARCKOPACITYBACKGROUND8})`,
};

const CityCard = ({ card, bookings = null, handleGetGuides=null }) => {
  const user = useSelector((state) => state.userSlice.user);
  const bookingsArr = useSelector((state) => state.userSlice.bookings);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const primaryImage = card?.media.find(
    (item) => item?.primary && item?.type === TYPEIMAGE
  );
  const primaryVideo = card?.media.find(
    (item) => item?.primary && item?.type === TYPEVIDEO
  );

  const handleNavigate = () => {
    if (user?.isAdmin) {
      navigate(`/travel/admin/${card?.id}`);
    } else {
      navigate(`/travel/${card?.id}`);
    }
  };

  const handleCanselBooking = async () => {
    if (bookings?.id?.length) {
      let res = await getBookingsCancel(bookings?.id);
      if (res?.id?.length && res.status === CANCELED) {
        if (handleGetGuides) {
          handleGetGuides('', 0);
        }
        dispatch(
          setShowMessageObj({
            open: true,
            status: "success",
            message: "Successfully canceled",
          })
        );
        trackMixpanel(CANCELEDGUIDE, {
          name: res?.name,
          price: res?.price,
          id: res?.id,
          dateTime: res?.dateTime,
          duration: res?.duration,
        });
      } else {
        console.log("res", res);
        dispatch(
          setShowMessageObj({
            open: true,
            status: "error",
            message: (res?.length && res) || SOMEERROR,
          })
        );
        trackMixpanel(APPERROR, {
          errorMessage: res || SOMEERROR,
          timestamp: new Date().toISOString(),
        });
      }
    }
  };

  const handleConnectBooking = async () => {
    if (bookings?.id?.length) {
      dispatch(setSelectedBookings(bookings));
      // navigate(`/travel/streaming/${bookings.id}?isBooker=${user.id === bookings?.booker?.id}`);
      navigate(`/travel/streaming/${bookings.id}`);
      handleCloseBookingIdAlert(dispatch);
    }
  };

  return (
    <Box
      p={"4px"}
      width={"100%"}
      sx={{
        background: "#fff",
        borderRadius: "24px",
        cursor: "pointer",
        "@media (min-width: 500px)": {
          width: "calc(50% - 8px)",
        },
        "@media (min-width: 900px)": {
          width: "calc(33% - 8px)",
        },
      }}
      onClick={handleNavigate}
    >
      <Box
        position={"relative"}
        width={"100%"}
        height={"180px"}
        sx={sxColumnStartBetween}
      >
        {!!card?.media?.length ? (
          <>
            <Box
              position={"absolute"}
              top={0}
              left={0}
              right={0}
              bottom={0}
              width={"100%"}
              height={"100%"}
              zIndex={1}
              sx={{
                borderRadius: "24px",
                background: `linear-gradient(to bottom, rgba(33, 37, 41, 0.24), ${DARCKOPACITYBACKGROUND8})`,
              }}
            />
            {primaryImage?.url ? (
              <Box
                component="img"
                alt="img"
                src={primaryImage.url}
                sx={sxImage}
              />
            ) : (
              <Box
                component="img"
                alt="img"
                src={primaryVideo?.preview}
                sx={sxImage}
              />
            )}
          </>
        ) : (
          <Box
            width={"100%"}
            height={"100%"}
            position={"absolute"}
            top={0}
            left={0}
            right={0}
            bottom={0}
            sx={{
              borderRadius: "24px",
              objectFit: "cover",
              background: `linear-gradient(to bottom, rgba(33, 37, 41, 0), ${DARCKOPACITYBACKGROUND8})`,
            }}
          >
            <NoPhotographyIcon
              sx={{
                color: "#fff",
                width: "32px",
                height: "32px",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
          </Box>
        )}
        <Stack
          width={"100%"}
          pl={1}
          sx={{
            ...sxRowCenterBetween,
            position: "relative",
            zIndex: 1,
          }}
        >
          <Typography
            variant="body1"
            height={"fit-content"}
            sx={{
              ...sxText1240016,
              background: DARCKOPACITYBACKGROUND6,
              borderRadius: "21px",
              padding: "4px 10px",
              color: "#fff",
            }}
          >
            {languageMap[card?.language] || card?.language}
          </Typography>
          {user?.isAdmin ? (
            <IconButton
              color="inherit"
              aria-label="arrow"
              sx={{
                background: DARCKOPACITYBACKGROUND6,
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                transform: "translate(-4px, 4px)",
                "&:hover": {
                  background: DARCKOPACITYBACKGROUND8,
                },
              }}
            >
              <EditIcon sx={{ color: "#fff", width: "16px", height: "16px" }} />
            </IconButton>
          ) : (
            <IconButton color="inherit" aria-label="arrow">
              <Box
                component="img"
                src={arrowImage}
                alt="img"
                sx={{
                  width: "32px",
                  height: "32px",
                }}
              />
            </IconButton>
          )}
        </Stack>
        <Stack
          width={"100%"}
          pl={2}
          pb={2}
          pr={2}
          sx={{
            ...sxRowCenterBetween,
            position: "relative",
            zIndex: 1,
          }}
        >
          <Stack gap={1} sx={sxRowCenterStart}>
            <Box
              component="img"
              src={locationImage}
              alt="img"
              sx={{
                width: "15px",
                height: "15px",
              }}
            />
            <Typography
              variant="body1"
              sx={{
                ...sxText1240016,
                color: "#fff",
              }}
            >
              {card?.location?.country}, {card?.location?.city}
            </Typography>
          </Stack>
          <Stack gap={1} sx={sxRowCenterStart}>
            <Box
              component="img"
              src={routingImage}
              alt="img"
              sx={{
                width: "15px",
                height: "15px",
              }}
            />
            <Typography
              variant="body1"
              sx={{
                ...sxText1240016,
                color: "#fff",
              }}
            >
              {Math.floor(card.duration / 3600) +
                (card.duration % 3600 === 0
                  ? "h"
                  : `h ${Math.floor((card.duration % 3600) / 60)}m`)}
            </Typography>
          </Stack>
        </Stack>
      </Box>
      <Stack width={"100%"} gap={1} p={"16px 8px 0"} sx={sxRowCenterBetween}>
        <Typography
          variant="body1"
          sx={{
            ...sxText1450020,
            color: DARCKCOLOR,
          }}
        >
          {card?.name}
        </Typography>
        <Box
          component="img"
          src={radarImage}
          alt="img"
          sx={{
            width: "20px",
            height: "20px",
          }}
        />
      </Stack>
      <Typography
        variant="body1"
        p={"0 8px 16px"}
        sx={{
          ...sxText1230016,
          color: "rgba(33, 37, 41, 0.7)",
        }}
      >
        {card?.shortDescription}
      </Typography>
      {location.pathname === "/travel/guides" && (
        <StatusCard
          status={bookings?.status?.length ? bookings?.status : CANCELED}
          dateTime={bookings?.dateTime}
          handleCanselBooking={handleCanselBooking}
          handleConnectBooking={handleConnectBooking}
        />
      )}
    </Box>
  );
};

export default CityCard;
